import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-check-out-dashboard',
  templateUrl: './mcommerce-virtual-cash-register-check-out-dashboard.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-check-out-dashboard.component.scss']
})
export class McommerceVirtualCashRegisterCheckOutDashboardComponent implements OnInit {

  cart;
  cartInfo;

  constructor() {
    this.cart = [
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' },
      { thumbnail: 'https://bit.ly/2nJOECC', description: 'Zumo de naranja natural 1L', trademark: 'Zumosol', ean: '9002236311036', time: '16:04', quantity: '2', unitPrice: '1,02', subtotalPrice: '2,04' }];
    this.cartInfo = {
      time: '16:03',
      name: 'Fernando García',
      cartSize: 6,
      comments: 'Lorem ipsum dolor sit amet consecteur adispicing elit',
      cash: 'CASH 1',
      totalAmount: '52,68'
    };
  }

  ngOnInit() { }

}
